export default "__VITE_ASSET__DuRQWBnE__"